import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import ToolParameterForm from "components/tools/parameters/ToolParameterForm";
import { createToolParameter } from "graphql/mutations";
import { getTool, toolParametersByToolID } from "graphql/queries";
import { Loader } from "@aws-amplify/ui-react";

const ToolParameterCreateForm = ({ toolID, onSuccess }) => {
  const navigate = useNavigate();
  const [companyID, setCompanyID] = useState("");
  const toolParameter = {
    parameterID: "",
    parameterValue: "",
  };

  async function onSubmit(valuesParam) {
    try {
      const { parameterID, parameterValue } = valuesParam;
      const oldToolParameterData = await API.graphql(
        graphqlOperation(toolParametersByToolID, {
          toolID,
          filter: {
            and: [
              {
                parameterID: { eq: parameterID },
              },
            ],
            deletedAt: { attributeExists: false },
          },
        })
      );
      const oldToolParameterItems =
        oldToolParameterData.data.toolParametersByToolID.items;

      if (oldToolParameterItems.length > 0) {
        toast.error(strings.parameterExists);
        return;
      }

      await API.graphql({
        query: createToolParameter.replaceAll("__typename", ""),
        variables: {
          input: {
            toolID,
            parameterID,
            parameterValue,
          },
        },
      });

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/tools");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function getCompanyFromTool(id) {
    try {
      const toolData = await API.graphql(graphqlOperation(getTool, { id }));
      const toolItem = toolData.data.getTool;
      if (!toolItem) {
        toast.error(strings.responses.errorFetchTool);
        return;
      }
      setCompanyID(toolItem.companyID);
    } catch (err) {
      toast.error(strings.responses.errorFetchTool);
    }
  }

  useEffect(() => {
    getCompanyFromTool(toolID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolID]);

  if (!companyID) return <Loader />;

  return (
    <div>
      <ToolParameterForm
        onSubmit={onSubmit}
        initialValues={toolParameter}
        companyID={companyID}
      />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Parámetro de Herramienta",
    successAdded: "Parámetro de Herramienta agregado con éxito",
    parameterExists: "El parámetro ya existe en la herramienta",
    responses: {
      errorFetchTool: "Error al consultar herramienta",
    },
  },
});

export default ToolParameterCreateForm;
